<template>
    <div class="onboarding-sidebar">
        <DrawerAccordion
            v-for="(accordion, index) in accordions"
            :id="`accordion-${index}`"
            :key="index"
            :title="accordion.title"
            :openByDefault="false"
        >
            <div
                class="onboarding-sidebar__accordion-content typographies-paragraph-medium-regular"
                v-html="accordion.content"
            />
        </DrawerAccordion>
    </div>
</template>
<script>
import DrawerAccordion from 'vcomponents/common/drawer/accordion/DrawerAccordion.vue';
export default {
    components: {
        DrawerAccordion,
    },
    data() {
        return {
            accordions: [
                {
                    title: this.$t.__('pdp.mandate.Onboarding.accordion_1.title'),
                    content: this.$t.__('pdp.mandate.Onboarding.accordion_1.content', {
                        paragraphStart: '<p>',
                        paragraphEnd: '</p>',
                    }),
                },
                {
                    title: this.$t.__('pdp.mandate.Onboarding.accordion_2.title'),
                    content: this.$t.__('pdp.mandate.Onboarding.accordion_2.content', {
                        paragraphStart: '<p>',
                        paragraphEnd: '</p>',
                        listStart: '<ul>',
                        listEnd: '</ul>',
                        listItemStart: '<li>',
                        listItemEnd: '</li>',
                        boldStart: '<strong>',
                        boldEnd: '</strong>',
                    }),
                },
                {
                    title: this.$t.__('pdp.mandate.Onboarding.accordion_3.title'),
                    content: this.$t.__('pdp.mandate.Onboarding.accordion_3.content', {
                        paragraphStart: '<p>',
                        paragraphEnd: '</p>',
                        listStart: '<ul>',
                        listEnd: '</ul>',
                        listItemStart: '<li>',
                        listItemEnd: '</li>',
                    }),
                },
            ],
            tagList: [
                this.$t.__('pdp.mandate.OnboardingSidebar.tag_1'),
                this.$t.__('pdp.mandate.OnboardingSidebar.tag_2'),
                this.$t.__('pdp.mandate.OnboardingSidebar.tag_3'),
            ],
        };
    },
};
</script>
<style lang="scss" scoped>
.onboarding-sidebar {
    &__accordion-content {
        color: var(--colors-common-text-subtle-default);

        &:deep(p) {
            margin: 0;

            & + p,
            & + ul {
                margin: var(--spacing-3) 0 0;
            }

            & + ul {
                list-style-type: disc;
                padding: 0 0 0 22px;
            }
        }
    }
}
</style>
